export let SwagBundlesStep = /*#__PURE__*/function (SwagBundlesStep) {
  SwagBundlesStep["naming"] = "naming";
  SwagBundlesStep["selectProducts"] = "selectProducts";
  SwagBundlesStep["selectColorsAndQuantities"] = "selectColorsAndQuantities";
  SwagBundlesStep["selectAddOns"] = "selectAddOns";
  SwagBundlesStep["calculateShipping"] = "calculateShipping";
  SwagBundlesStep["addOnsPayment"] = "addOnsPayment";
  return SwagBundlesStep;
}({});
export const SwagBundlesStepLabels = {
  [SwagBundlesStep.naming]: 'Bundle name',
  [SwagBundlesStep.selectProducts]: 'Select Products',
  [SwagBundlesStep.selectColorsAndQuantities]: 'Color(s) and quantities',
  [SwagBundlesStep.selectAddOns]: 'Select Add ons',
  [SwagBundlesStep.calculateShipping]: 'Select quantities',
  [SwagBundlesStep.addOnsPayment]: 'Pay for your add-ons'
};